import React from "react";

export default function Placeholder1() {
  return (
    <>
      <div className="Body">
        <header>
          <span className="text-decoration-underline">Placeholder1</span>
        </header>
      </div>
    </>
  );
}
